// extracted by mini-css-extract-plugin
export default {"boardContainer":"styles_boardContainer__3+o4U","board":"styles_board__1DFOo"};